var _circle, _path, _circle2, _path2, _circle3, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPresentemp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "multiEmpTitle"
  }, "Employees / Team") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "multiEmpTitle"
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 7,
    r: 3.5,
    fill: "rgba(57, 136, 111, 0.3)",
    stroke: "rgb(57, 136, 111)",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 19c0-3 2.5-5 5-5s5 2 5 5",
    fill: "rgba(57, 136, 111, 0.2)",
    stroke: "rgb(57, 136, 111)",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 9,
    r: 2.5,
    fill: "rgba(57, 136, 111, 0.2)",
    stroke: "rgb(57, 136, 111)",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 18c0-2.5 2-4 4-4",
    fill: "rgba(57, 136, 111, 0.1)",
    stroke: "rgb(57, 136, 111)",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 9,
    r: 2.5,
    fill: "rgba(57, 136, 111, 0.2)",
    stroke: "rgb(57, 136, 111)",
    strokeWidth: 1.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 14c2 0 4 1.5 4 4",
    fill: "rgba(57, 136, 111, 0.1)",
    stroke: "rgb(57, 136, 111)",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresentemp);
export default __webpack_public_path__ + "static/media/presentemp.2d0e4d8ce64665f2c63e6f0b3f127322.svg";
export { ForwardRef as ReactComponent };